import React from 'react'
import styled from 'styled-components'
import { StaticAssetsUrl } from 'redux/config/services/Constants'

const getImage = (image: string) => {
  if (image === 'setupWorkforce')
    return `${StaticAssetsUrl}/onboarding/onboarding_add_workers.png`
  else if (image === 'stripe')
    return `${StaticAssetsUrl}/onboarding/onboarding_add_payment.png`
  else if (image === 'doneOnboarding')
    return `${StaticAssetsUrl}/onboarding/onboarding_success.png`
  else return `${StaticAssetsUrl}/onboarding/onboarding_add_workers.png`
}

const Img = styled.img`
  align-self: center;
  height: 100%;
  width: 100%;
  object-fit: cover;
`

const RightImage = React.memo(({ imageType }: { imageType: string }) => (
  <Img alt='onboarding' src={getImage(imageType)} />
))

export default RightImage
